import http from "../http-common";

class TransactionDataService {

  lookup(sessionid)
  {
   
    return http.get(`/transaction/lookup/${sessionid}`);

  }

  addReceipt(data)
  {
   
    return http.post("/transaction/addreceipt", data);

  }

  success(data){
    return http.post("/transaction/receipt", data);
  }
 
  create(data) {
    return http.post("/transaction", data);
  }

  getAll() {
    return http.get("/transaction");
  }

}

export default new TransactionDataService();